<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 w-full items-start mb-8">
    <h2 class="text-xl font-bold tracking-tight text-foreground break-words">
      {{ headerTitle }}
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="text-sm font-medium leading-relaxed w-full max-w-3xl text-muted-foreground"
    />
  </div>
</template>
